import { render, staticRenderFns } from "./TransactionEditModalFormRemoveButton.vue?vue&type=template&id=60a7dfc2&"
import script from "./TransactionEditModalFormRemoveButton.vue?vue&type=script&lang=js&"
export * from "./TransactionEditModalFormRemoveButton.vue?vue&type=script&lang=js&"
import style0 from "./TransactionEditModalFormRemoveButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports